import(/* webpackMode: "eager" */ "/vercel/path0/app/projets/cursorHoverMask/page.jsx")